import { Component, OnInit } from '@angular/core';

import { SkipFinanceService } from '@app/configure/services/skip-finance.service';
import { ConfigureService } from '@app/configure/services/configure.service';

@Component({
	selector: 'cng-configure-finance-options',
	templateUrl: './finance-options.component.html',
	styleUrls: ['./finance-options.component.less'],
})
export class ConfigureFinanceOptionsComponent implements OnInit {
	current_step_key: string = 'finance_options';
	step_mode: string = this.configure_service.getStepMode();
	cashback_deal: boolean = this.configure_service.configure_data.meta.cashback_deal;

	constructor(private configure_service: ConfigureService, private skip_finance_service: SkipFinanceService) {
		if (!this.configure_service.isStepEnabled('finance_options')) {
			this.configure_service.navigateToStep('purchase_vehicle');
		}
	}

	ngOnInit(): void {
		this.configure_service.track('step.moved', { step: this.current_step_key }).subscribe();
		this.configure_service.trackJourney().subscribe();
	}

	jumpTo(new_step_key: string): void {
		// this.skip_finance_service.onJumpSteps(new_step_key, (canProceed: boolean) => {
		// 	if (canProceed) {
		this.saveAndGoTo(new_step_key);
		// 	}
		// });
	}

	hasFollowingSteps(): boolean {
		return (
			this.configure_service.isStepEnabled('delivery_options') || this.configure_service.isStepEnabled('payment')
		);
	}

	saveAndGoTo(new_step_key: string): void {
		this.configure_service.navigateToStep(new_step_key);
	}
}
